import { BranchCreate } from './BranchCreate';
import { BranchEdit } from './BranchEdit';
import { BranchList } from './BranchList';

export default {
    create: BranchCreate,
    edit: BranchEdit,
    list: BranchList
}
